import React from 'react';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-900 text-slate-400 py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <Logo variant="light" className="mb-4" />
            <div className="text-sm">AI-First Marketing Leader</div>
          </div>

          <div className="flex gap-8 text-sm">
            <button
              onClick={() => {
                const element = document.getElementById('about');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="hover:text-white transition-colors"
            >
              About
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('work');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="hover:text-white transition-colors"
            >
              Work
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('approach');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="hover:text-white transition-colors"
            >
              Approach
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="hover:text-white transition-colors"
            >
              Contact
            </button>
          </div>

          <button
            onClick={scrollToTop}
            className="text-sm hover:text-white transition-colors"
          >
            Back to top ↑
          </button>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-800 text-center text-sm">
          <p>© {currentYear} With Anshul. Built for clarity, not noise.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;